import { PathologyCreateOrderFormRequestSchema } from '@quromedical/models';
import { CrudForm, type SubmissionHandler } from 'components/form';
import type { Field } from 'components/types';
import { strings } from 'strings';

import type { PathologyCreateOrderForm } from './types';

type Props = {
  onSubmit: SubmissionHandler<PathologyCreateOrderForm>;
  fields: Field<PathologyCreateOrderForm>[];
  onChange: (formData: PathologyCreateOrderForm) => void;
};

export const LancetForm: React.FC<Props> = ({ fields, onChange, onSubmit }) => (
  <CrudForm
    fields={fields}
    initialValues={{}}
    validationSchema={PathologyCreateOrderFormRequestSchema}
    buttonText={strings.ButtonTextSubmit}
    onSubmit={onSubmit}
    onChange={onChange}
    onChangeDebounceTime={0}
  />
);
